/**
 * Log to the console, big and bold and colourful.
 *
 * @param text
 * @param args
 */

const isDev = (process.env.NODE_ENV == 'development');

export function boldlyLog(text, ...args) {
  const styles = "font-size: 125%; color: teal; font-weight: bold;";

  return console.log("%c%s", styles, text, ...args)
}

export function boldlyLogDev(text, ...args) {
  if (isDev) {
    return boldlyLog(text, ...args);
  }
  return false;
}

export function quietlyWarn(text, ...args) {
  if (isDev) {
    console.warn(text, ...args);
  }
}

export function devAlert() {
  //alert(JSON.stringify(devAlert.caller, null, 2));

  if (!isDev)
    return;

  let args = [...arguments].map( thingy => {
    if (typeof thingy === 'function')
      thingy = thingy();

    if (typeof thingy !== 'string')
      thingy = JSON.stringify(thingy, null, 2);

    return thingy;
  });

  alert(args.join(", "));
}
